<template>
  <div>
    <el-top-nav-menu-4
      :logo="logoWl"
      companyTitle="承运商开店申请"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      ref="topNavMenu"
    >
    </el-top-nav-menu-4>
    <template>
      <topTip></topTip>
      <div style="margin-top: 58px"></div>
    </template>
    <!--主体部分-->
    <div
      class="detail-box ccui-clearfix"
      style="
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
      "
    >
      <!--  主体左侧内容  -->
      <div
        class="detail-info"
        style="flex: 1; margin-right: 20px; position: relative"
      >
        <!--  审批状态 icon  -->
        <div
          class="detail-info-el-Label"
          style="position: absolute; top: 40px; right: 20px; z-index: 10"
        >
          <el-label
            :type="approving"
            v-if="approvingStatus"
            :key="approving"
          ></el-label>
        </div>

        <div class="ccui-app-container-detail" style="margin-top: 0px">
          <div class="ccui-app-container-detail-body">
            <el-tabs
              v-model="activeName"
              class="el-tabs__customize dic-sub-tabs-style01"
            >
              <el-tab-pane label="注册联系人" name="tab01">
                <!-- 申请用户名 -->
                <basicInfo
                  title="注册信息"
                  labelWidth="190px"
                  :field-list="infolable.personInfo"
                  :data-info="detailInfo"
                ></basicInfo>
              </el-tab-pane>
              <el-tab-pane label="开店申请" name="tab02">
                <basicInfo
                  title="企业信息"
                  labelWidth="190px"
                  :field-list="infolable.compInfo"
                  :data-info="businessInfo"
                ></basicInfo>
                <basicInfo
                  title="店铺信息"
                  labelWidth="190px"
                  :field-list="infolable.shopInfo"
                  :data-info="detailInfo"
                >
                  <template #file="{ slotData }">
                    <img :src="slotData.shopLogoUrl" alt="" />
                  </template>
                  <template #quyu="{ slotData }">
                    <span v-if="slotData.levelCode == 0">全国</span>
                    <div
                      v-if="slotData.levelCode == 1"
                      style="max-width: 500px;max-height: 140px;overflow: auto;"
                    >
                      <span
                        v-for="(categoryBosItem,
                        idx) in slotData.shopBusinessAreaScopeBOS"
                        :key="idx"
                        style="
                          line-height: 22px;
                          display: inline-block;
                          align-items: center;
                        "
                      >
                        {{ categoryBosItem.businessAreaName }}
                        {{
                          slotData.shopBusinessAreaScopeBOS.length - 1 > idx
                            ? "、"
                            : ""
                        }}
                      </span>
                    </div>
                  </template>

                  <template #category="{ slotData }">
                    <div
                      style="
                        height: 100px;
                        width: 350px;
                        overflow-y: auto;
                        border: 1px solid #f1f1f1;
                        padding: 0 5px;
                        box-sizing: border-box;
                      "
                    >
                      <div
                        v-for="(categoryBosItem,
                        idx) in slotData.shopBusinessCategoryScopeBOS"
                        :key="idx"
                        style="
                          display: flex;
                          align-items: center;
                          line-height: 22px;
                        "
                      >
                        {{ categoryBosItem.categoryNamePath }}
                      </div>
                    </div>
                  </template>
                  <template #subcategory="{ slotData }">
                    <div
                      v-if="slotData.levelCode == 1"
                      style="max-width: 500px;max-height: 140px;overflow: auto;"
                    >
                      <span
                        v-for="(subcategoryItem,
                        idx) in slotData.shopSupplierSubcategoryBOList"
                        :key="idx"
                        style="
                          line-height: 22px;
                          display: inline-block;
                          align-items: center;
                        "
                      >
                        {{ subcategoryItem.subcategoryName }}
                        {{
                          slotData.shopSupplierSubcategoryBOList.length - 1 > idx
                            ? "、"
                            : ""
                        }}
                      </span>
                    </div>
                  </template>
                </basicInfo>
                <basicInfo
                  title="上传材料"
                  labelWidth="190px"
                  :field-list="infolable.fileInfo"
                  :data-info="shopAptitudeInfo"
                >
                  <template #file="{ slotData }">
                    <template>
                      <div
                        v-if="slotData.fileUrl"
                        style="color: red; cursor: pointer"
                        @click="downloadUrlFile(slotData)"
                      >
                        下载附件
                      </div>
                    </template>
                    <img
                      v-if="slotData.fileName"
                      style="width: 80px; height:80px"
                      :src="getPoster(slotData) || slotData.fileUrl"
                      alt=""
                      @click="checkFile(slotData)"
                    />
                    <template>
                      <div
                        style="color: red; cursor: pointer"
                        @click="checkFile(slotData)"
                      >
                        {{ slotData.fileName }}
                      </div>
                    </template>
                  </template>
                </basicInfo>
                <el-card-title
                  class="detail-info-form-title self-title"
                  title="业绩证明"
                ></el-card-title>
                <attachmentUpload
                  ref="performanceCertificateRef"
                  :type="2"
                  style="width: 800px"
                ></attachmentUpload>
                <el-card-title
                  class="detail-info-form-title self-title"
                  title="意向合作单位"
                ></el-card-title>
                <el-table
                  :data="intentionUnitTableData"
                  border
                  class="dic-sub-table-style01"
                >
                  <el-table-column type="index" label="序号" width="50" />
                  <el-table-column
                    prop="intendedUnitName"
                    label="意向合作单位"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="运力路线信息" name="tab03">
                <div style="width: 740px; padding-top: 36px">
                  <el-table
                    :data="tableDataList"
                    border
                    @row-click="lookLineInfo"
                  >
                    <el-table-column
                      label="线路（起运地-目的地）"
                      :width="allWidth.shopName"
                    >
                      <template slot-scope="scope">
                        <span>
                          {{
                            scope.row.originProvinceName +
                              scope.row.originCityName +
                              "-" +
                              scope.row.destinationProvinceName +
                              scope.row.destinationCityName
                          }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="shopName"
                      label="店铺名称"
                      :width="allWidth.shopName"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="salePrice"
                      label="参考价"
                      align="right"
                      :width="allWidth.price"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="stockNum"
                      label="车辆数量"
                      align="right"
                      :width="allWidth.price"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="classifyNamePath"
                      label="商品分类"
                      :width="allWidth.classify"
                    >
                      <template slot-scope="scope">
                        <span
                          class="overNone"
                          :title="scope.row.classifyNamePath"
                          >{{ scope.row.classifyNamePath }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="运输物资类型"
                      :width="allWidth.shopName"
                    >
                      <template slot-scope="scope">
                        <span
                          class="overNone"
                          :title="
                            scope.row.skuLogisticsMatBOS
                              .map(item => item.matName)
                              .join(', ')
                          "
                          >{{
                            scope.row.skuLogisticsMatBOS
                              .map(item => item.matName)
                              .join(", ")
                          }}</span
                        >
                        <!--            <div class="overNone" :title="scope.row.skuLogisticsMatBOS.map(item=>{-->
                        <!--              return item.matName-->
                        <!--            })">-->
                        <!--              <p v-for="item in scope.row.skuLogisticsMatBOS"  :key="item.skuMatId">-->
                        <!--                {{ item.matName }}-->
                        <!--              </p>-->
                        <!--            </div >-->
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="服务费信息" name="tab04">
                <basicInfo
                  title="订单信息"
                  labelWidth="190px"
                  :field-list="infolable.orderMessage"
                  :data-info="orderInfo"
                ></basicInfo>
                <basicInfo
                  v-if="huiKuanInfo"
                  title="汇款信息"
                  labelWidth="190px"
                  :field-list="infolable.transferMessage"
                  :data-info="huiKuanInfo"
                >
                  <template #file="{ slotData }">
                    <template>
                      <div
                        style="color: red; cursor: pointer"
                        @click="downloadUrlFile(slotData)"
                      >
                        下载附件
                      </div>
                    </template>
                    <img
                      v-if="slotData.fileName"
                      style="width: 300px; height: 150px"
                      :src="getPoster(slotData) || slotData.fileUrl"
                      alt=""
                      @click="checkFile(slotData)"
                    />
                    <template>
                      <div
                        style="color: red; cursor: pointer"
                        @click="checkFile(slotData)"
                      >
                        {{ slotData.fileName }}
                      </div>
                    </template>
                  </template>
                </basicInfo>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <!--  右边审批状态  -->
      <div style="margin-bottom: 100px;">
        <approval-read-record
          v-if="auditStatus"
          :approvalRecordData="activities"
        />
      </div>
    </div>
    <el-dialog
      :close="handleClose"
      :visible.sync="dialogVisible2"
      show-shadow
      title="运力路线查看"
      width="1180px"
    >
      <lineInfo ref="lineInfo"></lineInfo>
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible2 = false"
          >返回</el-button
        >
      </span>
    </el-dialog>
    <!--底部功能按钮-->
    <el-bottom-guide>
      <ul class="ccui-bottom-button" style="max-width: 1180px; margin: 0 auto">
        <li>
          <el-button icon="icon-ccui-return" type="bottom" @click="handleBack"
            >返回
          </el-button>
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>
<script>
import topTip from "@/views/lessor-open-shop/components/topTip.vue";
import approvalReadRecord from "@/views/register/regView/components/approval-read-record.vue";

import infolable from "./base-info.js";
import imgBase64 from "./img-base64";
import basicInfo from "./basicInfolist.vue";
import lineInfo from "./lineInfo.vue";
import attachmentUpload from "@/views/lessor-open-shop/apply/attachmentUpload.vue";

import {
  queryShopAnnualFeeOrderPage,
  qryShopDetailByPhone,
  approvalDetail,
  queryCreateCommodity
} from "@/views/lessor-open-shop/api.js";
import { numberFilter } from "@/utils/index.js";
export default {
  components: {
    topTip,
    approvalReadRecord,
    basicInfo,
    lineInfo,
    attachmentUpload
  },
  name: "Approval",
  data() {
    return {
      intentionUnitTableData: [], //意向合作单位
      dialogVisible2: false,
      tableDataList: [],
      allWidth: {
        price: 100,
        status: 70,
        shopName: 250,
        classify: 120
      },
      infolable,
      imgBase64: Object.freeze(imgBase64),
      activeName: "tab01",
      logoWl: require("../images/logoWl.png"),
      baseUrl: this.$addUrlPerFix("wl.iccec.cn"),
      auditStatus: 1,
      accountInfo: {
        fileName: "sdasdaa.pdf"
      },
      detailInfo: {},
      businessInfo: {},
      orderInfo: {},
      shopAptitudeInfo: {},
      huiKuanInfo: null,
      activities: [],
      approving: "approving", // approving 审批中  sendback  审批退回     approvaled 审批通过
      approvingStatus: true // 审批状态展示
    };
  },
  computed: {},
  activated() {
    this.getInfo();
  },
  methods: {
    getTablestData() {
      const da = {
        shopId: this.detailInfo.shopId,
        isSecondPurchase: 3,
        // tabId:'2',
        pageNo: 1,
        pageSize: 100,
        isShowLoadding: true
      };
      queryCreateCommodity(da).then(res => {
        this.tableDataList = res.data.data.rows;
        this.tableDataList.forEach((item, index) => {
          item.shopName = this.detailInfo.shopName;
          item.salePrice =
            item.salePrice !== null
              ? "￥" + numberFilter(Number(item.salePrice)).newNum
              : "";
          item.purchasePrice =
            item.purchasePrice !== null
              ? "￥" + numberFilter(item.purchasePrice).newNum
              : "";
          item.marketPrice =
            item.marketPrice !== null
              ? "￥" + numberFilter(item.marketPrice).newNum
              : "";
        });
      });
    },
    handleBack() {
      // this.$router.back();
      this.$router.push({
        path: "/lessor-open-shop",
        query: { orderPurchaseType: 9, t: new Date().getTime() }
      });
    },

    getInfo() {
      const { phone, orderPurchaseType } = this.$route.query;

      qryShopDetailByPhone({ phone, orderPurchaseType }).then(res => {
        console.log(res, "*-*-approving*-*-*");
        if (res.data.code == 0) {
          this.detailInfo = res.data.data;
          this.businessInfo = res.data.data.businessInfoBO;
          //业绩证明
          this.$refs.performanceCertificateRef.fileTableData = this.detailInfo.shopPerformanceCertificationBOList;
          // 意向合作单位
          this.intentionUnitTableData = this.detailInfo.shopIntendedUnitBOList;
          const ff =
            res.data.data.shopAptitudeInfoBOS &&
            res.data.data.shopAptitudeInfoBOS.length > 0
              ? res.data.data.shopAptitudeInfoBOS[0]
              : {};
          const agF = res.data.data.shopAgreementFileBOS;
          const xyFile = agF && agF.length > 0 ? agF[0] : {};
          this.shopAptitudeInfo = {
            shopAptitudeInfoBOS: {
              fileName: ff.aptitudeName,
              fileUrl: ff.aptitudeUrl,
              downloadUrl: ff.downloadUrl,
              uploadId: ff.uploadId
            },
            shopAgreementFileBOS: {
              fileName: xyFile.aptitudeName,
              fileUrl: xyFile.aptitudeUrl,
              downloadUrl: xyFile.downloadUrl,
              uploadId: xyFile.uploadId
            }
          };

          // sessionStorage.setItem("shopInfo", JSON.stringify(this.detailInfo))
          if (this.detailInfo.approveStatus == 2) {
            this.approving = "approving";
          } else if (this.detailInfo.approveStatus == 4) {
            this.approving = "sendback";
          } else if (this.detailInfo.approveStatus == 3) {
            this.approving = "approvaled";
          }

          // this.$refs.lineInfo.setData(this.detailInfo);

          this.getTablestData();
          this.getApprovalInfo(res.data.data);

          // 已开店
          queryShopAnnualFeeOrderPage({ phone, orderPurchaseType }).then(re => {
            console.log(re, "*-*-*-*-*");
            this.orderInfo = re.data.data.rows.find(
              el => el.orderTypeName == "开店申请"
            );
            if (this.orderInfo) {
              this.huiKuanInfo = this.orderInfo.shopIntendedUnitBOList;
            } else {
              this.huiKuanInfo = null;
            }
          });
        }
      });
    },
    getPoster(slotData) {
      let aa = slotData.fileName ? slotData.fileName.split(".")[1] : "";
      if (["png", "jpg", "jpeg"].includes(aa)) {
        return false;
      } else if (["doc", "docx"].includes(aa)) {
        return imgBase64.doc;
      } else if (["xls", "xlsx"].includes(aa)) {
        return imgBase64.xls;
      } else {
        return imgBase64[aa];
      }
    },
    lookLineInfo(row, column, event) {
      this.dialogVisible2 = true;
      this.$nextTick(() => {
        this.$refs.lineInfo.setData(row);
      });
    },
    handleClose() {
      this.dialogVisible2 = false;
    },
    getApprovalInfo(val) {
      const { phone, orderPurchaseType } = this.$route.query;
      const da = {
        orderPurchaseType,
        phone,
        businessBillId: "1066",
        businessCode: "Y02",
        businessBillType: "Y0207",
        businessAppId: "107416",
        businessOrgId: "104577",
        currentOperUserId: "10002150449@104577"
      };
      approvalDetail({ ...da, ...val }).then(res => {
        console.log(res, "*-*-*-*-*");
        if (res.data.code == 0) {
          this.activities = res.data.data.recordList;
          //   this.approvingStatus = res.data.data.approvingStatus;
        }
      });
    },
    goApproval() {
      this.$router.push({ path: "/approval" });
    },
    checkFile(row) {
      console.log(row, "row");
      const filetype = row.fileName.match(/\.(\w+)$/)[1];
      const imgtype = ["png", "jpg", "jpeg", "gif", "PDF", "pdf"];
      if (imgtype.includes(filetype)) {
        window.open(row.fileUrl, "_blank");
      }
    },
    downloadUrlFile(row) {
      // let uploadId = row.uploadId;
      // window.open(
      //   `${location.origin}/apis/asca/file/download?uploadId=${uploadId}&agentId=100029`
      // );
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
      document.body.removeChild(openUrl);

      // this.$addUrlPerFix(
      //   process.env.VUE_APP_BASE_URL +
      //     "/apis/sra/reg/users/signup/downloadByUploadId"
      // )
    },

    handelDownload(res) {
      let blob = new Blob([res.data], {
        type:
          "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob);
      } else {
        let elink = document.createElement("a");
        if (
          res.headers["content-disposition"] &&
          res.headers["content-disposition"].split(";").length > 1 &&
          res.headers["content-disposition"].split(";")[1].split("filename*=")
            .length > 1
        ) {
          let filename = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename*=")[1];
          filename = window.decodeURIComponent(filename);
          filename = filename.split("utf-8''")[1];
          console.log(filename);
          elink.download = filename;
        }
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/config/styles/template-body";
</style>
